import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row items-center q-pb-sm" }

import { PropType, ref } from "vue"

//region Props and Emits

export interface FilterCheckBox {
  id: string
  label: string
  isChecked: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxFilterCheckBox',
  props: {
  checkBoxData: {
    type: Object as PropType<FilterCheckBox>,
    required: true,
  },
},
  emits: ["checkboxClicked"],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

//endregion

//region Variables

const isChecked = ref(props.checkBoxData.isChecked)

//endregion

//region Functions

function handleClick() {
  emit("checkboxClicked", props.checkBoxData.id)
}

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, _toDisplayString(props.checkBoxData.label), 1),
    _createVNode(_component_q_space),
    _createVNode(_component_q_checkbox, {
      modelValue: isChecked.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isChecked).value = $event)),
      onClick: handleClick,
      size: "48px",
      color: "secondary",
      dense: ""
    }, null, 8, ["modelValue"])
  ]))
}
}

})